import React, { ReactNode } from 'react';
import { Column } from './Column';
import styles from './Container.module.css';

interface ContainerProps {
  children: ReactNode;
  maxWidth?: string;
}

function Container({ children, maxWidth = '59.5rem' }: ContainerProps) {
  return (
    <div className={styles.container} style={{ maxWidth }}>
      <Column>{children}</Column>
    </div>
  );
}

export { Container };
